module.exports = __webpack_public_path__ + "static/media/paymentArrow.8ab449d8.svg";